import React from 'react';
import './PlaceholderContent.css';

function PlaceholderContent({ 
  pageName, 
  description, 
  features = [], 
  expectedDate = "Coming Soon",
  showContactInfo = true 
}) {
  return (
    <div className="placeholder-container">
      <div className="placeholder-content">
        <div className="placeholder-icon">
          <svg width="120" height="120" viewBox="0 0 120 120" fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="60" cy="60" r="58" stroke="#ff66b2" strokeWidth="2" strokeDasharray="8 4"/>
            <path d="M40 60L52 72L80 44" stroke="#F46B02" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
        
        <h2 className="placeholder-title">{pageName}</h2>
        
        {description && (
          <p className="placeholder-description">{description}</p>
        )}
        
        <div className="placeholder-badge">
          <span className="badge-text">{expectedDate}</span>
        </div>
        
        {features.length > 0 && (
          <div className="placeholder-features">
            <h3 className="features-title">Upcoming Features:</h3>
            <ul className="features-list">
              {features.map((feature, index) => (
                <li key={index} className="feature-item">
                  <span className="feature-icon">→</span>
                  <span className="feature-text">{feature}</span>
                </li>
              ))}
            </ul>
          </div>
        )}
        
        {showContactInfo && (
          <div className="placeholder-footer">
            <p className="contact-info">
              Questions about this feature? Contact{' '}
              <a href="mailto:support@cafuamanagement.com" className="contact-link">
                support@cafuamanagement.com
              </a>
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default PlaceholderContent;